import FolderById from '@/pages/folder/folder-by-id'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated-layout/group/$groupId/')(
  {
    component: () => <FolderById id={String(-1)} />,
  },
)

